var map = {
	"./0.svg": "buJT",
	"./1.svg": "NxHL",
	"./2.svg": "NC3X",
	"./3.svg": "gxIt",
	"./4.svg": "WduV",
	"./5.svg": "zwzX",
	"./6.svg": "/tgb",
	"./7.svg": "0Inm",
	"./8.svg": "AzDb",
	"./9.svg": "Z41b"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "B+24";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/numbers ^\.\/.*\.svg$
// module id = B+24
// module chunks = 0